import { render, staticRenderFns } from "./shopsList.vue?vue&type=template&id=4f996272&"
import script from "./shopsList.vue?vue&type=script&lang=js&"
export * from "./shopsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports